import axios from 'axios';

const IPINFO_TOKEN = process.env.REACT_APP_IPINFO_TOKEN;
let userIpCache = null;
let userIpCacheAt = 0;
const USER_IP_CACHE_TTL = 5 * 60 * 1000;

const buildErrorResult = (error, fallbackMessage) => {
  if (axios.isCancel(error)) {
    return {
      success: false,
      errorCode: 'CANCELLED',
      errorMessage: '请求已取消'
    };
  }

  let errorCode = 'GENERAL';
  let errorMessage = fallbackMessage;

  if (error.code === 'ECONNABORTED') {
    errorCode = 'TIMEOUT';
    errorMessage = '请求超时';
  } else if (error.response) {
    errorCode = 'SERVER_ERROR';
    errorMessage = `服务器错误: ${error.response.status}`;
  } else if (error.request) {
    errorCode = 'NETWORK';
    errorMessage = '网络错误';
  }

  return {
    success: false,
    errorCode,
    errorMessage: error.response?.data?.error || errorMessage
  };
};

// 创建可取消的请求源
const createCancelableRequest = (url, config = {}) => {
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();
  
  const request = axios.get(url, {
    ...config,
    cancelToken: source.token
  });
  
  return { request, cancel: source.cancel };
};

export const getIpInfo = async (ip = '', cancelToken = null) => {
  try {
    const url = ip
      ? `https://ipinfo.io/${ip}/json`
      : 'https://ipinfo.io/json';
    
    const config = IPINFO_TOKEN
      ? { params: { token: IPINFO_TOKEN } }
      : {};
    
    if (cancelToken) {
      config.cancelToken = cancelToken;
    }
    
    const response = await axios.get(url, config);
    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    if (!axios.isCancel(error)) {
      console.error('获取IP信息失败:', error);
    }
    return buildErrorResult(error, '获取IP信息失败');
  }
};

export const getUserIpInfo = async (cancelToken = null, { forceRefresh = false } = {}) => {
  try {
    if (!forceRefresh && userIpCache && Date.now() - userIpCacheAt < USER_IP_CACHE_TTL) {
      return {
        success: true,
        data: userIpCache
      };
    }
    const config = IPINFO_TOKEN 
      ? { params: { token: IPINFO_TOKEN } }
      : {};
    
    if (cancelToken) {
      config.cancelToken = cancelToken;
    }
    
    const response = await axios.get('https://ipinfo.io/json', config);
    userIpCache = response.data;
    userIpCacheAt = Date.now();
    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    if (!axios.isCancel(error)) {
      console.error('获取用户IP信息失败:', error);
    }
    return buildErrorResult(error, '获取用户IP信息失败');
  }
};

// 判断地图服务商选择逻辑
export const selectMapProvider = (userCountry, targetCountry) => {
  // 规则1: 查询IP归属中国，不论用户通过哪里的IP访问项目均使用AMAP
  if (targetCountry === 'CN') {
    return 'amap';
  }
  
  // 规则2: 用户IP归属中国 + 查询IP归属中国 → 使用AMAP (已在规则1中覆盖)
  // 规则3: 用户IP归属中国 + 查询IP不归属中国 → 使用BaiduMap
  if (userCountry === 'CN' && targetCountry !== 'CN') {
    return 'baidu';
  }
  
  // 规则4: 用户IP不归属中国 + 查询IP不归属中国 → 使用AzureMap
  if (userCountry !== 'CN' && targetCountry !== 'CN') {
    return 'azure';
  }
  
  // 默认使用AzureMap
  return 'azure';
};
